export default "__VITE_ASSET__C4hr0$Bg__"